(function(){
'use strict';
var io = new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('.reveal, .pcard').forEach(function(el){io.observe(el);});

var galleryContainer = document.querySelector('[data-gallery]');
if(galleryContainer){
  var slides = galleryContainer.querySelectorAll('.pdp-slide');
  var thumbs = galleryContainer.querySelectorAll('.pdp-thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(e){
      e.preventDefault();
      var idx = parseInt(t.getAttribute('data-thumb'), 10);
      slides.forEach(function(s,i){s.classList.toggle('is-active', i===idx);});
      thumbs.forEach(function(x,i){x.classList.toggle('is-active', i===idx);});
    });
  });
}

var mCta = document.querySelector('.pdp-mobile-cta');
var buyPanel = document.querySelector('.pdp-buy-col');
if(mCta && buyPanel){
  var showAfter = buyPanel.getBoundingClientRect().bottom + window.scrollY;
  window.addEventListener('scroll', function(){
    if(window.innerWidth > 768) return;
    mCta.classList.toggle('is-visible', window.scrollY > showAfter);
  }, {passive:true});
}

var grid = document.querySelector('[data-grid]');
if(grid){
  var cards = grid.querySelectorAll('.pcard');
  var chips = document.querySelectorAll('.col-chip, .chip');
  var searchInput = document.querySelector('[data-search]');
  var activeTag = 'all', activeSearch = '';
  function applyFilters(){
    cards.forEach(function(c){
      var tags = (c.getAttribute('data-tags')||'').toLowerCase();
      var text = c.textContent.toLowerCase();
      var tagMatch = (activeTag === 'all' || tags.indexOf(activeTag) !== -1);
      var searchMatch = (activeSearch === '' || text.indexOf(activeSearch) !== -1);
      c.classList.toggle('hidden', !(tagMatch && searchMatch));
    });
  }
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(x){x.classList.remove('is-active','active');});
      chip.classList.add('is-active','active');
      activeTag = (chip.getAttribute('data-tag') || 'all').toLowerCase();
      applyFilters();
    });
  });
  if(searchInput){
    searchInput.addEventListener('input', function(){
      activeSearch = searchInput.value.trim().toLowerCase();
      applyFilters();
    });
  }
}

var counter = document.getElementById('counter');
if(counter){
  var target = parseInt(counter.getAttribute('data-target') || '12847', 10);
  var start = performance.now();
  (function tick(now){
    var p = Math.min(1, (now - start) / 1800);
    var e = 1 - Math.pow(1 - p, 3);
    counter.textContent = '$' + Math.round(target * e).toLocaleString();
    if(p<1) requestAnimationFrame(tick);
  })(performance.now());
}

var cartCount = document.getElementById('cart-count');
if(cartCount && window.fetch){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){cartCount.textContent = c.item_count;}).catch(function(){});
}

// AJAX add-to-cart (progressive enhancement). Falls back to a native POST when
// fetch/FormData are unavailable. On success we send the buyer straight to
// checkout; on failure we surface a branded inline message instead of Shopify's
// generic /cart/add error page.
document.querySelectorAll('form.pdp-buy-form').forEach(function(form){
  form.addEventListener('submit', function(e){
    if(!window.fetch || !window.FormData) return;
    e.preventDefault();
    if(form.classList.contains('is-loading')) return;
    var btn = form.querySelector('[type="submit"]');
    var errEl = form.querySelector('[data-buy-error]');
    var originalHTML = btn ? btn.innerHTML : '';
    form.classList.add('is-loading');
    if(btn){ btn.setAttribute('aria-busy','true'); }
    if(errEl){ errEl.hidden = true; errEl.textContent = ''; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function(res){
      return res.json().then(function(data){ return { ok: res.ok, data: data }; });
    }).then(function(r){
      if(r.ok){ window.location.href = '/checkout'; return; }
      throw new Error((r.data && (r.data.description || r.data.message)) || 'This item could not be added to your cart.');
    }).catch(function(err){
      form.classList.remove('is-loading');
      if(btn){ btn.removeAttribute('aria-busy'); btn.innerHTML = originalHTML; }
      var msg = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
      if(errEl){ errEl.textContent = msg; errEl.hidden = false; }
      else { window.alert(msg); }
    });
  });
});
})();